import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  StyledWrapperDateSelector,
  StyledDropdownDay,
  StyledDropdownMonth,
  StyledDropdownYear,
  StyledError
} from './style';

import { getMonthName } from '../../../utils/dates';

const YEAR_SELECTOR = 'YEAR_SELECTOR';
const MONTH_SELECTOR = 'MONTH_SELECTOR';
const DAY_SELECTOR = 'DAY_SELECTOR';

const DateSelector = ({
  years,
  date,
  error,
  disabled,
  onChange,
  className
}) => {
  const [daySelect, setDaySelect] = useState([]);
  const [monthSelect, setMonthSelect] = useState([]);
  const [yearSelect, setYearSelect] = useState([]);
  const formatDate = dat => {
    const datNum = parseInt(dat, 10);
    return datNum < 10 ? `0${datNum}` : datNum.toString();
  };

  useEffect(() => {
    setDaySelect(date ? formatDate(moment(date).format('D')) : null);
    setMonthSelect(date ? formatDate(moment(date).format('M')) : null);
    setYearSelect(date ? formatDate(moment(date).format('YYYY')) : null);
  }, []);

  const formatYear = year => Number(moment().format('YYYY')) - year;

  const dateChange = (item, value) => {
    let maxDays;
    let day;
    let month;
    let year;
    switch (item) {
      case DAY_SELECTOR:
        setDaySelect(formatDate(value.value + 1));
        day = formatDate(value.value + 1);
        break;
      case MONTH_SELECTOR:
        maxDays = moment(
          `${yearSelect}-${formatDate(value.value + 1)}`,
          'YYYY-MM'
        ).daysInMonth();
        if (maxDays < daySelect) {
          setDaySelect(formatDate(maxDays));
          setMonthSelect(formatDate(value.value + 1));
        } else {
          setMonthSelect(formatDate(value.value + 1));
        }
        month = formatDate(value.value + 1);
        break;

      case YEAR_SELECTOR:
        maxDays = moment(
          `${formatYear(value.value)}-${monthSelect}`,
          'YYYY-MM'
        ).daysInMonth();
        if (maxDays < daySelect) {
          setDaySelect(formatDate(maxDays));
          setYearSelect(formatYear(value.value));
        } else {
          setYearSelect(formatYear(value.value));
        }
        year = formatYear(value.value);
        break;
      default:
        break;
    }
    if ((year || yearSelect) && (month || monthSelect) && (day || daySelect)) {
      onChange(
        /* eslint no-underscore-dangle: 0 */
        moment(
          `${year || yearSelect}-${formatDate(
            month || monthSelect
          )}-${formatDate(day || daySelect)}`
        )._d
      );
    } else {
      onChange(null);
    }
  };

  const dateSelected = date
    ? moment(
        `${yearSelect}-${formatDate(monthSelect)}-${formatDate(daySelect)}`
      )
    : moment();
  const yearCurrent = new Date().getFullYear();
  const yearsList = Array.from(new Array(years), (v, i) => ({
    value: i,
    text: (yearCurrent - i).toString()
  }));

  const monthsBase = moment.months();
  const monthsList = monthsBase.map((v, i) => ({
    value: i,
    text: getMonthName(i)
  }));
  const daysBase = dateSelected.daysInMonth();
  const daysList = Array.from({ length: daysBase }, (v, i) => ({
    value: i + 1,
    text: formatDate(i + 1)
  }));

  return (
    <StyledWrapperDateSelector className={className}>
      <StyledDropdownDay
        list={daysList}
        label={daySelect ? formatDate(daySelect) : 'Día'}
        changeSelect={e => {
          dateChange(DAY_SELECTOR, e);
        }}
        error={!!(!daySelect && error)}
        disabled={disabled}
      />
      <StyledDropdownMonth
        list={monthsList}
        label={monthSelect ? getMonthName(monthSelect - 1) : 'Mes'}
        changeSelect={e => dateChange(MONTH_SELECTOR, e)}
        error={!!(!monthSelect && error)}
        disabled={disabled}
      />
      <StyledDropdownYear
        list={yearsList}
        label={yearSelect ? formatDate(yearSelect) : 'Año'}
        changeSelect={e => dateChange(YEAR_SELECTOR, e)}
        error={!!(!yearSelect && error)}
        disabled={disabled}
      />
      {error && <StyledError>{error}</StyledError>}
    </StyledWrapperDateSelector>
  );
};

export default DateSelector;
